export default "__VITE_PUBLIC_ASSET__287c5fe5__"